// extracted by mini-css-extract-plugin
module.exports = {"video":"styles_video__P_kXJ","modal":"styles_modal__AEFAj","rotate":"styles_rotate__A5gld","rotate-reverse":"styles_rotate-reverse__h0A95"};